module.exports = __webpack_public_path__ + "static/img/dangriguahao.f1815fb5.png";